import request from '@/utils/request'
import queryString from 'querystring'
// 获取详情
export function bannerApi(data) {
    return request({
        url: '/trade/api/home/banner/list',
        method: 'get',
        params: data
    })
}

// 公告列表
export function noticetApi(data) {
    return request({
        url: '/trade/api/home/notice/list',
        method: 'get',
        params: data
    })
}

// 展示数据
export function statsDataApi(data) {
    return request({
        url: '/trade/api/home/show/data',
        method: 'get',
        params: data
    })
}

// banner详情
export function bannerDetailApi(data) {
    return request({
        url: '/trade/api/home/banner/detail',
        method: 'post',
        data: queryString.stringify(data)
    })
}

// 资讯列表
export function newsListApi(data) {
    return request({
        url: '/trade/api/home/news/list',
        method: 'get',
        params: data
    })
}
